import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name mic-signal
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTd2NCIgLz4KICA8cGF0aCBkPSJNMTggMTFhNiA2IDAgMDAtMy01LjE5NyIgLz4KICA8cGF0aCBkPSJNMiAxMWExMCAxMCAwIDAxNS04LjY2MiIgLz4KICA8cGF0aCBkPSJNMjIgMTFhMTAgMTAgMCAwMC01LTguNjYyIiAvPgogIDxwYXRoIGQ9Ik02IDExYTYgNiAwIDAxMy01LjE5NyIgLz4KICA8cGF0aCBkPSJNOSAyMWg2IiAvPgogIDxyZWN0IHg9IjEwIiB5PSI5IiB3aWR0aD0iNCIgaGVpZ2h0PSI4IiByeD0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/mic-signal
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const MicSignal: IconNode = [
  ['path', { d: 'M12 17v4' }],
  ['path', { d: 'M18 11a6 6 0 00-3-5.197' }],
  ['path', { d: 'M2 11a10 10 0 015-8.662' }],
  ['path', { d: 'M22 11a10 10 0 00-5-8.662' }],
  ['path', { d: 'M6 11a6 6 0 013-5.197' }],
  ['path', { d: 'M9 21h6' }],
  ['rect', { x: '10', y: '9', width: '4', height: '8', rx: '2' }],
];

export default MicSignal;
